















































































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';
import { Job } from '../../models/jobs/job';
import { Facility } from '../../models/jobs/facility';
import { getJobTypeText, getJobPayUnit ,getCategoryLabel } from '../MyJobs/MyJobsUtils';

@Component
export default class JobMainInfo extends Vue {
  $moment: any;
  @Prop() job;

  goToCompanyDetail(ccode: string) {
    this.$router.push({ name: 'CompanyProfile', params: { Code: ccode } });
  }

  get jobHiddenFields() {
    return vxm.configs.getGlobalConfigValue('JOB_HIDDEN_FIELDS') 
  }

  get canShowCompanyLink() {
    return vxm.configs.getGlobalConfigBooelanValue('SHOW_COMPANY_NAME_LINK_IN_JOB_CARD')
  }

  get salaryLabel() {
    return (job) => {
      let salaryHigh: any = job.jobPayRateHigh;
      if (salaryHigh && salaryHigh.toString().includes('.')) {
        salaryHigh = salaryHigh.toFixed(2);
      }
      let salaryLow: any = job.jobPayRateLow;
      if (salaryLow && salaryLow.toString().includes('.')) {
        salaryLow = salaryLow.toFixed(2);
      }
      let salaryLabel = this.getPayUnit(job)
        ? `Up to : ${job.jobCurrencyText}${job.jobPayRateHigh}/${
            job.jobPayUOMText
          }`
        : `Up to : ${job.jobCurrencyText}${job.jobPayRateHigh}`;
      if (job.jobPostingMetaData) {
        let salaryLabelMetaData = job.jobPostingMetaData.find(
          (meta: any) => meta.name === 'salaryLabel',
        );
        if (
          (salaryHigh || salaryLow) &&
          salaryLabelMetaData &&
          salaryLabelMetaData.extraConfig &&
          salaryLabelMetaData.extraConfig.PayRateLocale
        ) {
          salaryHigh = Number(salaryHigh).toLocaleString(
            salaryLabelMetaData.extraConfig.PayRateLocale,
          );
          salaryLow = Number(salaryLow).toLocaleString(
            salaryLabelMetaData.extraConfig.PayRateLocale,
          );
        }
        if (salaryLabelMetaData && salaryLabelMetaData.displayFormat) {
          if (!this.getPayUnit(job)) {
            return salaryLabelMetaData.displayFormat
              .replaceAll('{$.jobCurrencyText}', job.jobCurrencyText)
              .replace('{$.jobPayRateHigh}', salaryHigh)
              .replace('/{$.jobPayUOMText}', '')
              .replace('{$.jobPayRateLow}', salaryLow);
          } else {
            return salaryLabelMetaData.displayFormat
              .replaceAll('{$.jobCurrencyText}', job.jobCurrencyText)
              .replace('{$.jobPayRateHigh}', salaryHigh)
              .replace('{$.jobPayUOMText}', job.jobPayUOMText)
              .replace('{$.jobPayRateLow}', salaryLow);
          }
        } else {
          return salaryLabel;
        }
      } else {
        return salaryLabel;
      }
    };
  }

  jobDuration(job) {
    return job.durationText;
  }

  canShowField(fieldName) {
      if(this.jobHiddenFields){
          const hiddenFields = this.jobHiddenFields.split(',').map((field) =>
            field
              .trim()
              .toLowerCase()
              .replace(/\s/g, ''),
          );
          return !hiddenFields.includes(fieldName);
        }
      return true;  
  }

  jobStartTime(job: Job): string {
    const dateFormat = vxm.jobs.getCompanyDateFormat
      ? vxm.jobs.getCompanyDateFormat.toUpperCase()
      : 'DD-MMM-YYYY';
    if (
      job.startImmediately &&
      job.endDTTM &&
      this.$moment(job.endDTTM).isAfter(this.$moment(new Date())) &&
      !vxm.jobs.BrandingInfo.HIDE_DATE_RANGE_IN_JOB_CARD
    ) {
      return `Immediately to ${this.$moment(job.endDTTM).format(dateFormat)}`;
    }
    if (job.startImmediately) {
      return 'Immediately';
    }
    if (job.startDTTM && job.endDTTM &&
    !vxm.jobs.BrandingInfo.HIDE_DATE_RANGE_IN_JOB_CARD
    ) {
      return `${this.$moment(job.startDTTM).format(
        dateFormat,
      )} to ${this.$moment(job.endDTTM).format(dateFormat)}`;
    }
    if (job.startDTTM) {
      return this.$moment(job.startDTTM).format(dateFormat);
    }
    return '';
  }

  customJobTypeText(job: Job): string {
    const filterMetaData = vxm.jobs.FilterMetaData;
    if (filterMetaData && filterMetaData.length > 0) {
      const jobPostingCustomData = job.jobPostingCustomData;
      const jobTypeFilter = filterMetaData.filter(
        (filter) =>
          filter['displayOnJobCard'] && filter['displayOnJobCard'] === true,
      );
      if (jobTypeFilter && jobTypeFilter.length > 0) {
        let fieldName: string = jobTypeFilter[0]['name'];
        fieldName = fieldName.slice(
          fieldName.indexOf('.') + 1,
          fieldName.length,
        );
        return jobPostingCustomData && jobPostingCustomData[fieldName]
          ? jobPostingCustomData[fieldName]
          : '';
      }
    }
    return '';
  }

  customRemoteWorkingText(job: Job): string {
    const filterMetaData = vxm.jobs.FilterMetaData;
    if (!filterMetaData || filterMetaData.length == 0) {
      return '';
    }
    const jobTypeFilter = filterMetaData.filter(
      (filter) =>
        filter['displayOnJobCard'] === true &&
        filter['label'] === 'Location Type',
    );
    if (jobTypeFilter.length == 1) {
      let fieldName: string = jobTypeFilter[0]['name'];
      if (fieldName) {
        fieldName = fieldName.slice(
          fieldName.indexOf('.') + 1,
          fieldName.length,
        );
        const jobPostingCustomData = job.jobPostingCustomData;
        return jobPostingCustomData && jobPostingCustomData[fieldName]
          ? jobPostingCustomData[fieldName]
          : '';
      }
    }
    return '';
  }

  jobTypeText(job: Job): string {
    return this.$t(getJobTypeText(job)).toString();
  }

  getDefaultFacilityName(facility: any) {
    let companyCode = vxm.jobs.BrandingInfo.companycode;
    if (
      companyCode &&
      (companyCode.startsWith('EMRLD') ||
        companyCode.startsWith('KNTCARE') ||
        companyCode.startsWith('ALLIED') ||
        companyCode.startsWith('OUTSRC'))
    ) {
      let city = facility.city ? facility.city.trim() : facility.city;
      let state = facility.state ? facility.state.trim() : facility.state;
      return `${city}, ${state}`;
    } else {
      return facility.name;
    }
  }

  getFormattedLocationName(facility: any, jobPostingMetaData: any) {
    if (jobPostingMetaData) {
      let facilityMetaData = jobPostingMetaData.filter(
        (meta: any) => meta.name === 'facilityName',
      );
      if (facilityMetaData && facilityMetaData[0].displayFormat) {
        const city = facility.city ? facility.city.trim() : facility.city;
        const state = facility.state ? facility.state.trim() : facility.state;
        const country = facility.country
          ? facility.country.trim()
          : facility.country;
        const name = facility.name ? facility.name.trim() : facility.name;
        if(city!=null && state!=null){
        return facilityMetaData[0].displayFormat
          .replace('{$.Facility.City}', city)
          .replace('{$.Facility.State}', state)
          .replace('{$.Facility.Country}', country)
          .replace('{$.Facility.Name}', name);
      }
      else if(country!=null && state!=null){
        return state+','+country
      }
      else if(country!=null){
        return country
      }
      return null
    }
  }
    return this.getDefaultFacilityName(facility);
}
getCategoryLabelText(job) { 
    return getCategoryLabel(job);
  }
  get payRateNegotiableText() {
    return vxm.configs.getGlobalConfigValue('NEGOTIABLE_JOB_TEXT');
  }
  getPayUnit(job) {
    return getJobPayUnit(job);
  }
}
